export default __webpack_public_path__ + "26c8a87e04ec78e952a84a1f8d5cb8ab.png";